import React, { useState } from 'react'

const SimpleAccordion = ({ dataCategory: { name, description }, first, last }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <button
        style={{
          all: 'unset',
          cursor: 'pointer',
          padding: 10,
          borderTop: first ? '1px solid' : null,
          borderBottom: '1px solid',
          position: 'relative'
        }}
        onClick={() => setOpen(!open)}
      >
        {name}
        <span
          class={"chevron " + (open ? "up" : "down")}
          style={{ position: 'absolute', right: '1%', top: '35%' }}
        />
      </button>
      {open && (
        <div style={{ padding: 15, borderBottom: last ? null : '1px solid' }}>
          <p>
            {description}
          </p>
        </div>
      )}
    </>
  )
}

export default SimpleAccordion